<template>
  <div class="quiz-info-component">
    <h6 class="page-title text-center mb-5">
      <i class="icon-exam"></i> {{ quiz.title }}
    </h6>

    <h6 class="page-title text-center mb-2">Orientações:</h6>
    <div class="row justify-content-center">
      <div class="col-lg-8">
        <p class="orientations-description mb-5" v-html="quiz.description"></p>
      </div>
    </div>
    <div v-if="!isBlocked" class="d-flex justify-content-center mt-auto">
      <button class="btn btn-primary" @click="quiz_visible = true">
        Começar
      </button>
    </div>
    <p v-else class="text-center">{{ blockMsg }}</p>
    <quiz-modal
      v-if="quiz_visible"
      v-model="quiz_visible"
      :quiz="quiz"
      @update="$emit('update')"
    />
  </div>
</template>
<script>
import { diff_in_days, removeTimeZone } from "@/functions/helpers";
import QuizModal from "@/components/lesson/quiz/QuizModal";
import get from "lodash/get";

export default {
  components: { QuizModal },
  props: {
    quiz: {
      type: Object,
      default: () => {}
    },
    isBlocked: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      quiz_visible: false
    };
  },
  computed: {
    blockMsg() {
      const finished = get(this.quiz, "progress.finished_at", false);
      if (finished) {
        const date = new Date(removeTimeZone(finished));
        return `Prova finalizada em: ${date.toLocaleDateString()}`;
      }

      if (this.quiz.release_at) {
        const date = new Date(removeTimeZone(this.quiz.release_at));
        return `A prova estará disponível a partir de ${date.toLocaleDateString()}`;
      }

      if (this.quiz.days_to_release > 0) {
        const days_diff = diff_in_days(
          removeTimeZone(this.$user.user.created_at),
          new Date()
        );
        if (days_diff > 0) return `A prova estará disponível em ${days} dias`;

        return "";
      }

      return ``;
    }
  }
};
</script>
<style lang="scss" scoped>
.quiz-info-component {
  background-color: rgba(32, 32, 32, 0.24);
  padding: 60px 86px;
  min-height: 500px;
  display: flex;
  flex-direction: column;
  .page-title {
    .icon-exam {
      font-size: 20px;
    }
  }
  .orientations-description > *,
  .orientations-description {
    text-align: center;
    font-feature-settings: "clig" off, "liga" off;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }
}
</style>
